module.exports = __webpack_public_path__ + "img/si-verde.ebd106a2.svg";